import React from 'react';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useCommonContext } from '../../../../../contexts/CommonContext';
import { useI18nContext } from '../../../../../contexts/I18nContext';
import { Observer } from 'mobx-react-lite';
import MessageCard from '../../../../../ui_components/MessageCard/MessageCard';
import CustomCategorySalePriceStore from './CustomCategorySalePriceStore';
import CustomCategorySalePricesProperties from './CustomCategorySalePricesProperties';
import { useStyles } from './CustomCategorySalePrices.style';
import CustomCategorySalePriceRow from './CustomCategorySalePricesRow/CustomCategorySalePriceRow';
import { PackageDeliveryType } from '../../../../../model/packageDelivery/PackageDeliveryType';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import ButtonSize from '../../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../../ui_components/Button/ButtonType';
import NewPackageCustomCategoryWeightRangeSalePriceButton from '../../../../../shared_components/Buttons/NewPackageCustomCategoryWeightRangeSalePriceButton/NewPackageCustomCategoryWeightRangeSalePriceButton';
import CopyServicePricesButton from '../../../../../shared_components/Buttons/CopyServicePricesButton/CopyServicePricesButton';
import SalePriceItemType from '../../../../../entities/SalePriceItemType';

const CustomCategorySalePrices: React.FC<CustomCategorySalePricesProperties> = ({
    salePrice,
    onUpdate = () => {
    },
}) => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const store = new CustomCategorySalePriceStore(commonStore);
    const classes = useStyles();

    store.searchCustomCategories();

    const getDeliveryTypeIcon = (deliveryType: string) => {
        switch (deliveryType) {
            case PackageDeliveryType[PackageDeliveryType.PLANE]:
                return <AirplanemodeActiveIcon></AirplanemodeActiveIcon>;
            case PackageDeliveryType[PackageDeliveryType.SHIP]:
                return <DirectionsBoatIcon></DirectionsBoatIcon>;
            case PackageDeliveryType[PackageDeliveryType.EXPRESS]:
                return <AccessAlarmsIcon></AccessAlarmsIcon>;
            case PackageDeliveryType[PackageDeliveryType.SEMI_EXPRESS]:
                return <AddAlarmIcon></AddAlarmIcon>;
            default:
                return <></>;
        }
    }

    const getDeliveryTypeText = (deliveryType: string) => {
        switch (deliveryType) {
            case PackageDeliveryType[PackageDeliveryType.PLANE]:
                return 'Avión';
            case PackageDeliveryType[PackageDeliveryType.SHIP]:
                return 'Barco';
            case PackageDeliveryType[PackageDeliveryType.EXPRESS]:
                return 'Express';
            case PackageDeliveryType[PackageDeliveryType.SEMI_EXPRESS]:
                return 'Semi Express';
            default:
                return <></>
        }
    }

    return (
        <Observer>
            {() => (
                <div className={classes.package_sale_prices_container}>
                    <div className={classes.new_button_container}>
                        <CopyServicePricesButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            sourceSalePriceId={salePrice?.id ?? ''}
                            serviceName={SalePriceItemType.PACKAGE_CUSTOM_CATEGORY_WEIGHT_RANGE}
                            type={ButtonType.SECONDARY}
                        />
                    </div>
                    {!store.isEmpty &&
                    <div className={classes.package_sale_prices_table}>
                        {
                            store.customCategories.map((customCategory, i) => (
                                <div className={classes.category_container} key={customCategory.id}>
                                    <div className={classes.category_header}>
                                        <div className={classes.category_name}>{customCategory.name}</div>
                                        <div>
                                            <NewPackageCustomCategoryWeightRangeSalePriceButton
                                                size={ButtonSize.SMALL}
                                                onSave={onUpdate}
                                                showText
                                                salePriceId={salePrice?.id ?? ''}
                                                customCategoryId={customCategory.id}
                                                type={ButtonType.SECONDARY}
                                            />
                                        </div>
                                    </div>
                                    <div className={classes.elements_container}>
                                        {Object.keys(PackageDeliveryType)
                                            .filter((key) => isNaN(Number(key))).map((deliveryType, i) => (
                                            <div>
                                                <div className={classes.delivery_type_header}>
                                                    <div>
                                                        {getDeliveryTypeIcon(deliveryType)}
                                                    </div>
                                                    <div>{getDeliveryTypeText(deliveryType)}</div>
                                                </div>
                                                {salePrice?.packageCustomCategoryWeightRangeSalePrices
                                                    .filter(t => 
                                                        t.customCategoryId === customCategory.id &&
                                                        t.deliveryType.toString() === deliveryType).map((weightRange, index) => (
                                                        <CustomCategorySalePriceRow
                                                            onUpdate={onUpdate}
                                                            customCategoryWeightRangeSalePrice={weightRange}
                                                            salePrice={salePrice}
                                                            key={index}
                                                        />
                                                ))}
                                                {/* {store.customCategoryWeightRanges
                                                    .filter(t => t.customCategoryId === customCategory.id &&
                                                        t.deliveryType.toString() === deliveryType).length === 0 && 
                                                    <MessageCard className={classes.empty_delivery_type} title={'No hay precios para este tipo de envío!!!'}/>
                                                } */}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))
                        }
                    </div>}
                    {store.isEmpty &&
                    <MessageCard icon={CurrencyExchangeIcon} title={i18n.translate("NO_MONEY_SERVICE_FEE_TITLE")}
                                subtitle={i18n.translate("NO_MONEY_SERVICE_FEE_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default CustomCategorySalePrices;
